export const formatPrice = (
    apartment,
    rate,
    isPercent = false,
    values = null,
    remainAmount,
    repair,
    all,
    discount,
    priceMetr,
    previousOrderPrice = 0 // Oldingi bron to'lovi (ayirish uchun)
) => {
    if (!apartment?.pricePerMetrSquare && !rate) return null;

    // Asosiy narx (discount qo'llanmagan)
    let basePrice = priceMetr ? apartment.pricePerMetrSquare * rate : apartment.pricePerMetrSquare * rate * apartment.m2;

    let repairPrice = repair * rate * apartment.m2;

    let finalPrice = basePrice;

    // Agar perMonth yuborilgan bo'lsa
    if (values?.isInstallmentPayment) {
        // Avval discount qo'llaymiz
        let basePriceAll = repair
            ? (basePrice + repairPrice) - (((basePrice + repairPrice) * discount) / 100)
            : basePrice - ((basePrice * discount) / 100);

        // Keyin previousOrderPrice ayiramiz (discount qo'llangandan keyin)
        if (previousOrderPrice > 0 && !priceMetr) {
            basePriceAll = basePriceAll - previousOrderPrice;
        }

        if (isPercent) {
            finalPrice = (basePriceAll * values?.downPaymentPercent) / 100; // foiz
        } else if (remainAmount) {
            finalPrice = ((basePriceAll * (100 - values?.downPaymentPercent)) / 100); // qoldiq
        } else {
            finalPrice = ((basePriceAll * (100 - values?.downPaymentPercent)) / 100) / values?.paymentDurationPerMonth; // oyga bo'lish
        }
    } else if (repair && !all) {
        finalPrice = repairPrice;
    } else if (repair && all) {
        finalPrice = repairPrice + basePrice;
        console.log(repairPrice + basePrice);
    }

    if (discount && !values?.isInstallmentPayment) {
        console.log(finalPrice);
        finalPrice = typeof discount === "number" ? finalPrice - ((finalPrice * discount) / 100) : finalPrice - ((finalPrice * 15) / 100);
        console.log(finalPrice);
    }

    // Non-installment: previousOrderPrice ayirish (discount qo'llangandan keyin)
    if (previousOrderPrice > 0 && !priceMetr && !values?.isInstallmentPayment) {
        finalPrice = finalPrice - previousOrderPrice;
    }

    // 1 xonali aniqlik
    finalPrice = Math.round(finalPrice * 10) / 10;

    // 1 234 567 format
    return finalPrice
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
